module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bs-056e551cfb3bba660804eec90aff9866.svg";